import type { I18N } from '@vista-digital/i18n'
import type { Film, OrderTicketLine, Showtime, Site } from '@vista-digital/ocapi-types/v1'
import { getTicketTypeById } from '@vista-digital/occ-domain'
import type { EcommerceItem, EcommerceShowtimeProps } from '../models-gtm'
import { EcommerceShowtimeItem } from '../models-gtm'
import { mapFilmData } from './mapFilmData'
import { mapShowTimeData } from './mapShowtimeData'

export const getTicketItems = (
    ticketLines: OrderTicketLine[],
    film: Film,
    showtime: Showtime,
    site: Site,
    i18n: I18N
): EcommerceShowtimeItem[] => {
    const filmData = mapFilmData(film, i18n)
    const showtimeData = mapShowTimeData(showtime, site, i18n)

    return ticketLines.map(ticketLine => getTicketItem(filmData, showtimeData, ticketLine))
}

export const getTicketItem = (
    filmData: EcommerceItem,
    showtimeData: EcommerceShowtimeProps,
    ticketLine: OrderTicketLineWithQuantity
): EcommerceShowtimeItem => {
    const { quantity = 1 } = ticketLine
    const ecCommerceTicketItem: EcommerceShowtimeItem = {
        ...filmData,
        ...showtimeData,
        quantity: quantity,
        price: ticketLine.price.valueIncludingTax * quantity,
        item_variant: getTicketTypeById(ticketLine.ticketTypeId).description.text,
    }

    return new EcommerceShowtimeItem(ecCommerceTicketItem)
}

export type OrderTicketLineWithQuantity = OrderTicketLine & { quantity?: number }
